app.service('accountUserDataView', function (validate, loading, accountConfig, companyName, regon, vies, addressIntegrityValidator, broker) {

	let $self, $form, $addressRow, $addressBox, $vatUe, $nip, $companyName, $country, $countryUe, $countryId, $city, $street, $flat, $taxIdentifierSelector, $idNumber, $taxIdTypeBoxes, $zipCode;
	let config, taxIdType, frontUserType;

	function toggleCompanyBox() {
		if (frontUserType === 'COMPANY') {
			$addressBox.addClass('user-company');
			$flat.text('Numer lokalu');
		} else {
			$addressBox.removeClass('user-company');
			$flat.text('Numer mieszkania');
		}
		setTaxIdTypeBox();
	}

	function setTaxIdTypeBox() {

		$taxIdTypeBoxes
			.removeClass('active')
			.filter((i, el) => el.dataset.type === taxIdType)
			.addClass('active');

		renderForm();
		updateValidation();
	}

	function updateValidation() {

		if (frontUserType === 'INDIVIDUAL') {
			ignoreAllCompanyFields();

		} else { // COMPANY
			ignoreAllCompanyFields();
			enableCompanyFieldsValidation(taxIdType);
		}
	}

	function ignoreAllCompanyFields() {
		$idNumber.ignore(true);
		$vatUe.ignore(true);
		$nip.ignore(true);
		$countryUe.ignore(true);
		$countryId.ignore(true);
		$companyName.ignore(true);
	}

	function enableCompanyFieldsValidation(type) {

		let fieldsToValidate = {
			'NIP': () => {
				$nip.ignore(false);
				$companyName.ignore(false);
			},
			'VAT_UE': () => {
				$vatUe.ignore(false);
				$companyName.ignore(false);
				$countryUe.ignore(false);
			},
			'NUMBER_ID': () => {
				$idNumber.ignore(false);
				$companyName.ignore(false);
				$countryId.ignore(false);
			},
			'EMPTY_ID': () => {
				$companyName.ignore(false);
			}
		}

		return fieldsToValidate[type]();
	}

	function triggerVatUeValidation() {
		$form.validate().element($countryUe);
		$form.validate().element($vatUe);
	}

	function renderForm() {

		if (taxIdType === "VAT_UE") {
			$countryId.attr('disabled', 'disabled');
			$countryUe.removeAttr('disabled');
		}

		if (taxIdType === "NUMBER_ID") {
			$countryUe.attr('disabled', 'disabled');
			$countryId.removeAttr('disabled');
		}
	}

	function close(id) {
		if (id === 'user-edit') {
			$self.removeClass('show-user-edit-form');
		}
	}


	function setEvents() {
		$self
			.on('click', 'input[type=radio]', e => {
				frontUserType = e.target.value;
				toggleCompanyBox();
			})
			.on('click', '#clear-address-data', () => {
				validate.resetForm($('#user-address'));
				$('#user-address input').trigger('input');
				$('#country').val('PL').trigger('change');
			})
			.on('change', '#address-form input', function () {
				validate.removeBackendError($(this));
			})
			.on('change', '#tax-identifier-selector', function handleTaxIdentifierChange() {
				taxIdType = $(this).val();

				$countryId.val('').trigger('change');
				$countryUe.val('').trigger('change');

				setTaxIdTypeBox();
			})
			.on('click', '.js-cancel-user-edit', function () {
				close('user-edit');
			})
			.on('click', '.js-email-send', function () {
			var $emailForm = $('#email-form');
			if ($emailForm.valid()) {
				loading.start();
				$emailForm.submit();
			}
		}).on('click', '.js-pass-send', function () {
			var $passForm = $('#password-form');
			if ($passForm.valid()) {
				loading.start();
				$passForm.submit();
			}
		}).on('click', '.js-account-remove', function () {
			loading.start();
			$('#remove-account-form').submit();
		});
		$countryId.on('change', function () {
			$form.validate().element($countryId);
		});

		$("#phone").keyfilter(/[\d\- ]/);

		validate.task('userDataAddress', function submitHandler($form) {

			loading.start();

			if ($country.val() !== 'PL') {
				$form.submit();
				return;
			}

			if (isEmpty($city) && isEmpty($zipCode) && isEmpty($street)) {
				$form.submit();
				return; // pomijamy walidację adresu
			}

			addressIntegrityValidator.validate({
				data: {
					cityName: $city.val(),
					zipCode: $zipCode.val(),
					street: $street.val(),
					checkHomeAddress: true,
				},
				onSuccess: () => $form.submit()
			});
		});

		$country.on('change', function () {

			if ($zipCode.val().length) {
				$form.validate().element($zipCode);
			}

			if ($country.val() === 'PL') {
				$zipCode.mask2("99-999");
				autocompleteDelivery('zip-code', 'city-name', 'street');
			} else {
				$zipCode.unmask2("99-999");
				unautocompleteDelivery('zip-code', 'city-name', 'street');
			}

			setZipCode($country.val());

			if (hasChangedPolishCountryCode($country)) {
				$('#zip-code, #city-name, #street, #house-number ,#flat-number').val(''); // czyścimy dane adresowe
			}

			$(this).data('prev-value', $(this).val());
		});

		if ($country.val() === 'PL') {
			$zipCode.mask2("99-999");
			autocompleteDelivery('zip-code', 'city-name', 'street');
		}

		vies.init({
			$box: $('#address-box .vies-box'),
			$button: $('#address-box .js-vies-button'),
			$vatNumber: $vatUe,
			$country: $countryUe,
			$taxIdSelector: $taxIdentifierSelector,
			nipEuValidate: config.nipEuValidate,
			validatedVatUeNumbers: config.validatedVatUeNumbers,
			onVatUeValidationUpdated: triggerVatUeValidation
		});

		broker.on('VIES_VERIFICATION_FINISHED', function (event, result) {
			if (result.success) {
				updateValidatedVatUeNumbersConfig(result.countryCode, result.vatUeNumber);
				triggerVatUeValidation();
			}
		});

		function updateValidatedVatUeNumbersConfig(countryCode, vatUeNumber) {
			if (!config.validatedVatUeNumbers.some(entry => entry[countryCode] && entry[countryCode].includes(vatUeNumber))) {
				config.validatedVatUeNumbers.push({[countryCode]: [vatUeNumber]});
			}
		}

		companyName.init('company-name');
		$('#id-number-div').on('input', function() {
			$idNumber.val($(this).text());
			$form.validate().element($idNumber);
		});
		regon.init({
			$country: $country,
			$box: $('#company-box .regon-box'),
			$nip: $nip,
			$companyName: $('#company-name-textarea-div'),
			$city: $city,
			$street: $street,
			$houseNumber: $('#house-number'),
			$flatNumber: $('#flat-number'),
			$zipCode: $zipCode
		});
	}

	function isEmpty($field) {
		return $field.val().trim() === "";
	}

	function hasChangedPolishCountryCode($countryCode) {
		const previousValue = $countryCode.data('prev-value');
		const currentValue = $countryCode.val();

		if (previousValue === 'PL' && currentValue !== 'PL') {
			return true;
		}

		return previousValue !== 'PL' && currentValue === 'PL';
	}

	function setZipCode(countryCode) {
		const isPolishCountryCode = countryCode === 'PL';
		const maxLength = isPolishCountryCode ? 6 : 8;
		const type = isPolishCountryCode ? 'tel' : 'text';

		$zipCode.prop({
			'maxlength': maxLength,
			'type': type
		});
	}

	function init() {

		config = accountConfig.getData();
		frontUserType = config.frontUserType;
		taxIdType = config.taxIdType || "NIP";

		$self = $('#user-edit');
		$addressRow = $('#address-row');
		$addressBox = $('#address-box');
		$taxIdTypeBoxes = $addressBox.find('.tax-id-type-box');
		$form = $('form', $addressRow);
		$vatUe = $('#nip-eu');
		$zipCode = $('#zip-code');
		$nip = $('#nip');
		$idNumber = $('#id-number');
		$country = $('#country');
		$city = $('#city-name');
		$street = $('#street');
		$countryUe = $('#country-eu');
		$countryId = $('#country-id');
		$companyName = $('#company-name-textarea');
		$taxIdentifierSelector = $('#tax-identifier-selector');
		$flat = $('label[for=flat-number]', $addressBox);

		setEvents();
		renderForm();
	}


	return {init};
});
